import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

import UserUpdateModal from '../components/modals/UserUpdateModal';
import authContext from '../context/authContext/authContext';
import errorHanle from '../utils/errorHandle';

import { deleteUserAction, getUsersAction } from '../redux/actions/userAction';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import UserDetailsModal from '../components/modals/UserDetailsModal';
import PartnerStatus from '../components/PartnerStatus';
import DematStatus from '../components/DematStatus';

const DELETE_USER_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/deleteUser";

const DEFAULT_USER_IMAGE = "assets/images/photo8.jpg";

const DematUsers = () => {
  const { getConfig } = useContext(authContext)
  const config = getConfig()
  const dispatch = useDispatch();
  const { users, loading } = useSelector(state => state?.users)

  const intialState = { users: [] }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const getUsers = () => {
    const data = { dematOnly: true }
    dispatch(getUsersAction(config, data))
  }

  useEffect(() => {
    getUsers()
  }, []);

  const onUserIdClick = (userId) => {
    if(!userId) {
      return;
    }

    setState({ reqUserId: userId, showUserDetailsModal: true })
  }

  const deleteUser = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        cofirmDeleteUser(id);
      }
    });
  }

  const cofirmDeleteUser = async (id) => {
    const data = { id }
    dispatch(deleteUserAction(data, config, getUsers))
  }

  return (
    <div className="main-container">
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">GleamDesk Demat requests</h2>
            {loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover text-center">
            <thead>
              <tr>
                <th scope="col">Image</th>
                <th scope="col">Name</th>
                <th scope="col">Email / ID</th>
                <th scope="col">Phone</th>
                <th scope="col">GT</th>
                <th scope="col">Aadhar</th>
                <th scope="col">Pan</th>
                <th scope="col">Partner</th>
                <th scope="col">DEMAT</th>
                <th scope="col">Refer Id</th>
                <th scope="col">Created At</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(users || []).map((user) => {
                const { _id: userId, image, name, email, phone, gdTokens, createdAt, aadhar, pan, isPartner, referId, clientId, dematStatus } = user;
                return (
                  <tr key={userId}>
                    <td className='cursor-pointer' onClick={() => onUserIdClick(userId)}>
                      <img src={image || DEFAULT_USER_IMAGE} className='user-profile-image' alt="user avatar" />
                    </td>
                    <th scope="row" className='name'>{name || '-'}</th>
                    <td>
                      <div>{email || '-'}</div>
                      <div className='fs-12 btn-user-info' onClick={() => onUserIdClick(userId)}>{userId}</div>
                    </td>
                    <td>{phone || '-'}</td>
                    <td>{gdTokens || 0}</td>
                    <td>{aadhar || "-"}</td>
                    <td>{pan || "-"}</td>
                    <td><PartnerStatus isPartner={isPartner} /></td>
                    <td>
                      <DematStatus dematStatus={dematStatus} />
                      <div className='fs-12'>{clientId}</div>
                    </td>
                    <td className='cursor-pointer btn-user-info' onClick={() => onUserIdClick(referId)}>{referId || "-"}</td>
                    <td>
                      <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                      <div className='text-muted fs-12'>{moment(createdAt).format("h:mm a")}</div>
                    </td>
                    <td className='actions-container'>
                      <button className='btn btn-secondary btn-sm my-1 mx-1' onClick={() => setState({ openUserUpdateModal: true, userId: userId })}>
                        <i className='fa fa-pencil' />
                      </button>
                      <button className='btn btn-danger btn-sm my-1 mx-1' onClick={() => deleteUser(userId)}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
      <UserUpdateModal
        isOpen={state.openUserUpdateModal}
        toggle={() => setState({ openUserUpdateModal: false, userId: null })}
        userId={state?.userId}
        users={users || []}
        getUsers={getUsers}
      />

      <UserDetailsModal
        isOpen={state.showUserDetailsModal}
        toggle={() => setState({ reqUserId: '', showUserDetailsModal: false })}
        reqUserId={state.reqUserId}
      />
    </div>
  )
}

export default DematUsers